module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-order-log"
  }, [(!_vm.listData.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n      暂无数据\n    ")]) : _vm._l((_vm.listData), function(item) {
    return _c('ul', {
      key: item.workOrderNo
    }, [_c('li', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-left"
    }, [_c('h3', {
      staticClass: "title-name"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.detail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "left-line"
    }, [_c('span', {
      staticClass: "smalltitle"
    }, [_vm._v("工单编号")]), _c('span', {}, [_vm._v(": " + _vm._s(item.workOrderNo))])]), _vm._v(" "), (item.customerName) ? _c('p', {
      staticClass: "left-line"
    }, [_c('span', {
      staticClass: "smalltitle"
    }, [_vm._v("客户名称")]), _c('span', [_vm._v(": " + _vm._s(item.customerName))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "left-line"
    }, [_c('span', {
      staticClass: "smalltitle"
    }, [_vm._v("负责人")]), _c('span', [_vm._v(": " + _vm._s(item.manager))])]), _vm._v(" "), (item.state) ? _c('p', {
      staticClass: "left-line"
    }, [_c('span', {
      staticClass: "smalltitle"
    }, [_vm._v("工单阶段")]), _c('span', [_vm._v(": " + _vm._s(item.state))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "left-line"
    }, [_c('span', {
      staticClass: "smalltitle"
    }, [_vm._v("提交时间")]), _c('span', [_vm._v(": " + _vm._s(item.time))])]), _vm._v(" "), (item.rateStar && item.rateStar >= 0) ? _c('p', {
      staticClass: "left-line"
    }, [_c('span', {
      staticClass: "smalltitle"
    }, [_vm._v("评价星级")]), _vm._v(": "), _c('el-rate', {
      staticClass: "rate-star",
      attrs: {
        "disabled": ""
      },
      model: {
        value: (item.rateStar),
        callback: function($$v) {
          _vm.$set(item, "rateStar", $$v)
        },
        expression: "item.rateStar"
      }
    })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('p', {
      staticClass: "consumeTime",
      class: {
        isOut: item.isOut === 1
      }
    }, [_vm._v(_vm._s(item.consumeTime))]), _vm._v(" "), _c('p', {
      staticClass: "statusStr",
      class: 'col-' + item.status
    }, [_vm._v(_vm._s(item.statusStr))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n        加载更多\n      ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.size) ? [_vm._v("没有更多")] : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8262644","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/work-order-log.vue
// module id = 1331
// module chunks = 82